import { SafeLogErrorOptions } from '../log-error';
import { BaseError } from './BaseError';

export class XivaError extends BaseError {
    constructor(message: string, loggerFields: SafeLogErrorOptions, stack?: string) {
        super(
            message,
            {
                source: 'backend',
                block: 'xiva',
                ...loggerFields,
            },
            stack
        );

        Object.setPrototypeOf(this, XivaError.prototype);
    }
}
